import { Suspense, useEffect, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const PickingListTool = lazy(() => import('~/apps/smartsend/components/warehouse/PickingListTool'));

export default function Component() {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useEffect(() => {
    const title = t('PICKING_LIST_TITLE', { defaultValue: 'Picking List' });
    document.title = title;
  }, [t]);

  return (
    <Suspense>
      <PickingListTool />
    </Suspense>
  );
}

Component.displayName = 'Picking List';
